define('features/mirai-fuel-stations',[
  'jquery',
  'Maps',
  'lib/util/tda.config',
  'zipTools',
  'cookies',
  'storageUtil',
  'responsive',

  // side effect includes
  'bat',
  'isInViewport'
], function (
  $,
  buildMap,
  tdaConfig,
  zipTools,
  cookies,
  storageUtil,
  responsive
) {
  var fuelStations = fuelStations || {
    init: function () {
      if (responsive() === 'sm') {
        window.location.hash = 'land';
      }

      $(window).on('hashchange', function () {
        if (fuelStations.lastState === '#results' && responsive() === 'sm') {
          fuelStations.resetInitView();
        }
        // THIS IS ONLY REALLY USED IN MOBILE FOR 'BACKBUTTON'
        fuelStations.lastState = window.location.hash;
      });

      var currentTDACode = tdaConfig.tda.code;
      var qs = {};
      if (window.location.search) {
        $.each(document.location.search.substr(1).split('&'), function (c,q) {
          var i = q.split('=');
          if (i && (i.length === 2)) { // PROPERLY FORMED QUERY PARAMS.
            qs[i[0].toString()] = i[1].toString();
          }
        });
      }

      this.listeners.attach();

      if (qs['search']) {
        fuelStations.isSearchUrl = true;
        /*

          use this:
          $("input[data-id='search-value']");

        */
        var st = qs['search']; //USE VAR
        // THERE IS A SEARCH TERM , PASSED IN FROM MINI MIRAI FUEL SEARCH COMPONENT.
        // $('#search-value').val(unescape(qs.search));
        $("input[data-id='search-value']").val(unescape(qs.search));
        // fuelStations.locations.searchStations($('#search-value').val());
        fuelStations.locations.searchStations($("input[data-id='search-value']").val());
        if (qs['id']) {
          fuelStations.stationId = qs['id'];
        }
      } else {
        // NO SEARCH TERM.
        var promisedGetMap = this.getMap(currentTDACode);
        promisedGetMap.done(function (obj) {
          $('#introMap').css({
            'background-image': 'url(' + obj.mapImgUrl + ')'
          }).removeClass('container').addClass('container-fullwidth');
          $('.dealer-search-input-wrap').show();
          $('.dealer-search-intro').show();
          $('.map-overlay').show();
          window.bat.util.loader.hideLoader();
        });

        if (cookies.getItem('miraiFuelSearch')) {
          $('#search-value').val(unescape(cookies.getItem('miraiFuelSearch')));
        }
      }
    },

    // IF MOBILE USERS ARE IN RESULTS VIEW AND THEY HIT BACK BUTTON, RESET TO INTRO VIEW.
    resetInitView: function () {
      $('#fuelMapConMob').empty();
      $('#fuelMapCon').empty();

      $('.stations-panel').hide();
      $('.stations-panel-results').empty();
      $('.stations-panel-header').hide();
      $('.stations-panel-results').hide(); // THE RESULTS WILL TOGLGLE.
      var currentTDACode = tdaConfig.tda.code;
      var promisedGetMap = fuelStations.getMap(currentTDACode);
      promisedGetMap.done(function (obj) {
        $('#introMap').css({
          'background-image': 'url(' + obj.mapImgUrl + ')'
        });
        $('.dealer-search-input-wrap').show();
        $('.dealer-search-intro').show();
        $('.map-overlay').show();
        window.bat.util.loader.hideLoader();
      });
      $('.m-dealer-search').show();
      $('.map-inner').show();
    },

    getMap: function (currentTDACode) {
      var deferredMap = $.Deferred();
      var currentZip = storageUtil.getZip();
      // GET FRESH MAP. ERRORS WITH LOCAL STORAGE.
      var lw = Math.round(window.innerWidth);
      var lh = Math.round(window.innerHeight * 0.75);
      var lsize = lw.toString() + 'x' + lh.toString();
      var mapsize = lsize;
      // STYLESTRING TAKEN FROM THE MAP INFO ZIP INCLUDED WITH TICKET. , see BAT references for BAT25-139: map-url-updated-damo.txt OR THE .json file.
      var styleString = 'format=png&maptype=roadmap&style=element:geometry.fill%7Ccolor:0xf1f1f2&style=element:labels%7Cvisibility:off&style=feature:administrative.land_parcel%7Cvisibility:off&style=feature:administrative.land_parcel%7Celement:labels%7Cvisibility:off&style=feature:administrative.neighborhood%7Cvisibility:off&style=feature:landscape.man_made%7Celement:geometry.fill%7Ccolor:0xf1f1f2&style=feature:landscape.natural%7Celement:geometry.fill%7Ccolor:0xf1f1f2&style=feature:poi%7Celement:labels%7Cvisibility:off&style=feature:poi%7Celement:labels.text%7Cvisibility:off&style=feature:poi.park%7Celement:geometry.fill%7Ccolor:0xf1f1f2&style=feature:road%7Celement:geometry.fill%7Ccolor:0xffffff&style=feature:road.arterial%7Celement:labels%7Cvisibility:off&style=feature:road.highway%7Celement:geometry.fill%7Ccolor:0xdadada&style=feature:road.highway%7Celement:geometry.stroke%7Cvisibility:off&style=feature:road.local%7Celement:labels%7Cvisibility:off';
      var signatureService = '/BATWS/map/key?url=https://';
      var size = mapsize;
      var zoom = 13;
      // map of USA for WWW
      if (currentTDACode === 'WWW') {
        currentZip = 'USA';
        zoom = 5;
      }
      // TODO: find out why this fails if replacing client with our actual API key
      var mapImage = signatureService + escape('maps.googleapis.com/maps/api/staticmap?center=' + currentZip + '&size=' + size + '&scale=1&zoom=' + zoom + '&client=gme-toyotamotorsales&channel=buyatoyota.com' + styleString);
      var fallbackMapImage = 'https://maps.googleapis.com/maps/api/staticmap?center=' + currentZip + '&size=' + size + '&scale=1&zoom=' + zoom + '&key=AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8' + styleString;

      $.ajax({
        type: 'GET',
        url: mapImage
      }).done(function (mapImgUrl) {
        var obj = {
          tda: currentTDACode,
          mapImgUrl: mapImgUrl
        };
        deferredMap.resolve(obj);
      }).fail(function (jqXHR, textStatus, errorThrown) {
        var obj = {
          tda: currentTDACode,
          mapImgUrl: fallbackMapImage
        };
        deferredMap.resolve(obj);
      });
      return deferredMap.promise();
    },

    listeners: {
      isZipFormatValid: function (testZip) {
        var pattern = /(^\d{5}$)|(^\d{5}-\d{4}$)/;
        return pattern.test(testZip);
      },

      attach: function () {
        $('.m-dealer-search').h5Validate();
        $('.m-dealer-search').submit(function (e) {
          if ($('.m-dealer-search').h5Validate('allValid') === false) {
            e.preventDefault();
          }
        });

        // PANEL TOGGLE
        $('.panel-text').on('click', function() {
          fuelStations.togglePanel();
        });

        // SUBMIT SEARCH ( FIND STATIONS BTN )
        $('#search-submit').on('click', function (e) {
          e.preventDefault();
          // fuelStations.locations.searchStations($('#search-value').val().toString());
          fuelStations.locations.searchStations($("input[data-id='search-value']").val().toString());
        });

        // SEARCH ICON BTN
        $('#iconSearch').on('click', function () {
          var sv = $('#search-value-header').val();
          if (!sv || sv === '') {
            // NO SEACH TERM
            return;
          }
          // THIS INDICATES THAT WE HAVE ALREADY INITIALZED SEARCH ONCE AND THE PANEL NOW APPEARS WITH THE SECONDARY SEARCH FIELD.
          fuelStations.useHeaderSearchValue = true;
          // DO SEARCH:
          fuelStations.locations.searchStations(sv.toString());
          // REVEAL THE PANEL RESULTS.
          if (responsive() !== 'sm') {
            fuelStations.togglePanel(true);
          }
        });

        // HANDLER FOR LOCATE ICONS:
        $('#autolocate').add('#autolocate-header').on('click', function () {
          // remove our geoIgnore cookie, user is no longer ignoring our zip prompt
          cookies.removeItem('geoIgnore', '/', zipTools.getCrossDomainCookieDomain());
          window.fuelStations.locations.locate();
        });
      }
    },

    togglePanel: function (isIconSearch) {
      if (!fuelStations.panelLeft) { // store the default open position.
        fuelStations.panelLeft = $('.panel-toggle').position().left;
      }
      if (isIconSearch && $('.panel-toggle').position().left > 10) {
        // no need to collapse the panel, we have a search going on and the panel is open.
        return;
      }
      // toggle results panel and the toggler.
      var newwidth = 0;
      if ($('.panel-toggle').position().left === 10) { // open it
        $('.stations-panel-results').stop().animate({ left: '0' }, 350);
        $('.panel-toggle').stop().animate({ left: fuelStations.panelLeft }, 350);
        $('#expandList').hide();
        $('#collapseList').show();
        $('.icon-arrow-up').show();
        $('.icon-arrow-down').hide();
        newwidth = window.innerWidth - 385;
        $('#fuelMapCon').removeClass('expanded');
      } else { // close it.
        $('.stations-panel-results').stop().animate({ left: '-100%' }, 350);
        $('.panel-toggle').stop().animate({ left: '10' }, 350);
        $('#toggle-label').text('Expand List');// TODO: GET TRANSLATION.
        $('#expandList').show();
        $('#collapseList').hide();
        $('.icon-arrow-up').hide();
        $('.icon-arrow-down').show();
        newwidth = window.innerWidth;// - 35;
        $('#fuelMapCon').addClass('expanded');
      }

      $('#fuelMapCon').width(newwidth);

      var mapId = document.getElementById('fuelMapCon');
      fuelStations.maps.google.maps.event.trigger(mapId, 'resize');
      setTimeout(function () {
        fuelStations.maps.google.maps.event.trigger(mapId, 'resize'); // YES, WE ARE CALLING IT TWICE.
        // fuelStations.locations.centerMap(fuelStations.selectedItemCoords.lat, fuelStations.selectedItemCoords.lng, true);
      }, 400);
    },

    locations: {
      setItemSelected: function (markerIndex) {
        $('.result-item').each(function (idx, item) {
          if (idx === markerIndex) {
            $(item).addClass('selected').siblings().removeClass('selected');
            // BAT-3486
            fuelStations.maps.showActiveMarker(idx);
          }
        });
      },

      updateDataLayer: function() {
        // var searchTerm = $('#search-value').val().toString();
        var searchTerm = $("input[data-id='search-value']").val().toString();
        if (fuelStations.useHeaderSearchValue) {
          searchTerm = $('#search-value-header').val().toString();
        }
        var dataToAdd = {
          'metrics': 'km-dealer-search',
          'dealer_search_term': searchTerm,
          'dealer_search_results_count': String(fuelStations.allLocations.length),
          'dealer_search_brand': 'Toyota'
        };
        $.extend(window.dataLayerBAT.data, dataToAdd);
      },

      initStateMapWithDealerData: function (markers, dealerData, mapContId) {
        fuelStations.previousZoom = 0;
        fuelStations.currentZoom = 0;
        buildMap()
          .then(function (MapsConstructor) {
            var maps = new MapsConstructor({
              kind: 'multimarker',
              markers: markers,
              numberedMarkers: true,
              dealerData: dealerData,
              mapElement: document.getElementById(mapContId),
              useFuelStyle: true
            });
            fuelStations.maps = maps;

            if (responsive() !== 'sm') {
              fuelStations.maps.map.addListener('zoom_changed', function () {
                if (fuelStations.resultItemClick) { // PREVENT ZOOMING FROM LIST CLICKS ( AS THEY AUTO ZOOM)
                  fuelStations.resultItemClick = false;
                  return;
                }
                if (fuelStations.previousZoom === 0) {
                  fuelStations.previousZoom = fuelStations.maps.map.getZoom();
                } else {
                  fuelStations.currentZoom = fuelStations.maps.map.getZoom();
                  if (fuelStations.currentZoom < fuelStations.previousZoom) {
                    // FETCH MORE STATIONS
                    if (fuelStations.allLocations.length >= fuelStations.allResults.length) {
                      return;
                    }
                    fuelStations.displayPagerNum++;
                    fuelStations.locations.loadResults(null, true, true);
                  } else {
                    if (fuelStations.displayPagerNum === 1) {
                      return;
                    }
                    // FETCH MORE STATIONS
                    fuelStations.displayPagerNum--;
                    fuelStations.locations.loadResults(null, true, true);
                  }
                  fuelStations.previousZoom = fuelStations.maps.map.getZoom();
                }
              });
            }
            if (fuelStations.useGeoLocate && fuelStations.storedUserLocation && responsive() === 'sm') {
              fuelStations.maps.displayLocation(fuelStations.storedUserLocation);
            }
          })
          .catch(function (err) { console.log('err from Maps: ', err); });
      },

      centerMap: function (lat, lng, isToggle) {
        var center = new fuelStations.maps.google.maps.LatLng(lat, lng);
        fuelStations.maps.map.setCenter(center);

        if (!isToggle) {
          fuelStations.maps.map.setZoom(15);
        }
      },

      // AUTO LOCATE.
      locate: function () {
        var success = function (newZip) {
          fuelStations.useGeoLocate = true; // BAT25-139: USED IN loadResults to display user location.
          // $('#search-value').val(newZip).removeClass('ui-state-error').addClass('ui-state-valid');
          $("input[data-id='search-value']").val(newZip).removeClass('ui-state-error').addClass('ui-state-valid');
          fuelStations.locations.searchStations(newZip);
        };
        // on fail, we just show the zip entry modal via window.zipTools.reLoadDealerSearchWithoutZip
        zipTools.geoLocationZip.detect(success, zipTools.reLoadDealerSearchWithoutZip);
      },

      showErrorModal: function () {
        window.bat.util.loader.hideLoader();
        $('#modal-station-results-error').modal('show');
        $('#dismiss-stations-modal').on('click', function () {
          $('#modal-station-results-error').modal('hide');
        });
      },

      searchStations: function (searchTerm) {
        if (!searchTerm || searchTerm === '') {
          $('#search-submit').blur();
          $("input[data-id='search-value']").focus();
          return;
        }
        searchTerm = searchTerm.toString();

        var isNumber = false;
        if (searchTerm.match(/^\d+$/)) { // TEST FOR NUMBER, ZIP.
          isNumber = true;
        }
        if (isNumber && searchTerm.length !== 5 ) {
          fuelStations.locations.showErrorModal();
          return;
        }
        var threedays = new Date((new Date()).valueOf() + 1000 * 3600 * 72);
        cookies.setItem('miraiFuelSearch', searchTerm , threedays, '/', zipTools.getCrossDomainCookieDomain());
        window.bat.util.loader.showLoader();
        $.ajax({
          type: 'GET',
          // url: '/fcv-consumer/fcvappservice/getAllFuelStations/94947?callback=fuelStations.locations.loadResults',
          //https://next.ws.tms.aws.toyota.com/fcv-consumer/fcvappservice/getAllFuelStations/' + escape(searchTerm) + '?callback=fuelStations.locations.loadResults
          url: '/fcv-consumer/fcvappservice/getAllFuelStations/' + escape(searchTerm) + '?callback=fuelStations.locations.loadResults',
          dataType: 'json'
        }).done(function (data) {
          fuelStations.locations.loadResults(data);
          // handled in callback...

        }).fail(function (jqXHR, textStatus, errorThrown) {
          console.error('FUEL REQUEST  FAIL: ', textStatus + errorThrown);
          fuelStations.locations.showErrorModal();
        });
      },

      loadResults: function (locationsResponseData, isViewMore, zoomed) {
        if (window.dataLayerBAT.utils) {
          window.dataLayerBAT.utils.triggerEvent(document, 'DL.PAGE_LOAD');// trigger page load for 'subpage' loads.
        } else {
          $(document).on('DL.DL_READY', function () {
            window.dataLayerBAT.utils.triggerEvent(document, 'DL.PAGE_LOAD');// trigger page load for 'subpage' loads.
          });
        }
        var previousScrollTop = $('.stations-panel-results').scrollTop();
        if ((!locationsResponseData || !locationsResponseData.length) && !isViewMore) {
          var currentTDACode = tdaConfig.tda.code;
          var promisedGetMap = fuelStations.getMap(currentTDACode);
          promisedGetMap.done( function (obj) {
            $('#introMap').css({
              'background-image': 'url(' + obj.mapImgUrl + ')'
            });
            $('.dealer-search-input-wrap').show();
            $('.dealer-search-intro').show();
            $('.map-overlay').show();
          });

          fuelStations.locations.showErrorModal();
          return;
        }

        if (responsive() === 'sm') {
          window.location.hash = 'results';
        }

        // CHECK FIRST THREE ITEMS FOR distanceWithoutMiles. if they're 0, means results are invalid.
        // 3 is an aribtrary number, but seems to work.
        if (!isViewMore) {
          var allzeroes = true;
          for (var i = 0; i < 2; i++) {
            if (locationsResponseData[i].distanceWithoutMiles !== 0) {
              allzeroes = false;
            }
          }
          if (allzeroes) {
            // REMOVE VALS AND CLEAR COOKIE.
            // $('#search-value').val('');
            $("input[data-id='search-value']").val('');
            $('#search-value-header').val('');
            cookies.removeItem('miraiFuelSearch', '/', zipTools.getCrossDomainCookieDomain());
            fuelStations.locations.showErrorModal();
            return;
          }
        }
        $('.map-overlay').hide();
        $('.stations-panel-results').empty();
        if (locationsResponseData) { // THIS IS NEW SEARCH.
          fuelStations.displayPagerNum = 1;// RESET THE PAGINATION NUMBER.
          fuelStations.allResults = locationsResponseData;
        }
        // var searchValue = unescape($('#search-value').val());
        var searchValue = unescape($("input[data-id='search-value']").val());
        if (fuelStations.useHeaderSearchValue) {
          searchValue = unescape($('#search-value-header').val());
        }

        var locationsData = {locations:[]};
        var resultNum = fuelStations.displayPagerNum * 5;
        fuelStations.allLocations = fuelStations.allResults.slice(0, resultNum);// locationsResponseData.slice(0,3);

        // UPDATE DATALAYER, TRIGGER CLICK EVENT.
        fuelStations.locations.updateDataLayer();
        fuelStations.markers = [];

        // BAT-5003 - Only show Open stations (status = 'Open_Now')
        // Build a separate 'Open Now' array and iterate over that one
        // instead of all locations
        var openStationsArray = [];
        $.each(fuelStations.allLocations, function (i, locationItem) {
          if (locationItem.status === 'Open_Now') {
            openStationsArray.push(locationItem);
          }
        });

        // $.each(fuelStations.allLocations, function (indx, locItem) {
        $.each(openStationsArray, function (indx, locItem) {
          var lpath = '/' + tdaConfig.site.context_url + '/mirai/stations?search=' + escape(searchValue) + '&id=' + locItem.id;
          var coords = {lat:locItem.lat, lon:locItem.lng, closed:locItem.status !== 'Open_Now'}
          locItem.coords = coords;
          fuelStations.markers.push(coords);
          var statusClass = 'status-default';
          if (locItem.status === 'Open_Now') {
            statusClass = 'status-open';
          }
          var isSafari = $('html').hasClass('safari');
          var isMac = $('html').hasClass('mac');
          var isFF = $('html').hasClass('firefox');

          var address = locItem.addressLine1 + locItem.addressLine2;
          address = address.replace(',', '');// example: "1605 VFW ParkwayBoston, MA 02132"
          var urlfa = address.replace(/ /g, '+');
          var mapurl = 'https://maps.google.com/?daddr=' + urlfa;
          // if this is safari or Mac Firefox, let's use apple maps. (Chrome on mac does not handle maps.apple links nicely)
          if (isSafari || (isMac && isFF)) {
            mapurl = 'https://maps.apple.com/?daddr=' + urlfa;
          }

          var pinImage = '/assets/img/maps/marker-blue-bg@2x.png';
          if (locItem.status !== 'Open_Now') {
            pinImage = '/assets/img/maps/marker-grey-bg@2x.png';
          }
          locationsData.locations.push({
            resultCount: (indx + 1),
            index: indx,
            id: locItem.id,
            name: locItem.name,
            addressLine1: locItem.addressLine1,
            addressLine2: locItem.addressLine2,
            distanceWithoutMiles: locItem.distanceWithoutMiles,
            actionDetailsUrl: lpath,
            mapurl: mapurl,
            status: locItem.statusDesc,
            statusClass: statusClass,
            coords: coords,
            pinImage: pinImage
          });
        });

        $('#search-value-header').val(searchValue);
        $('#introMap').css({ // remove the background image. can get localstroage version later if need be.
          'background-image': 'none'
        });
        if (responsive() !== 'sm') {
          $('#fuelMapCon').show();
        } else {
          $('#fuelMapConMob').hide();
        }

        $('.stations-panel').show();
        $('.stations-panel-header').show();
        $('.stations-panel-results').show(); // THE RESULTS WILL TOGLGLE.
        $('.m-dealer-search').hide();
        $('.map-inner').hide();

        var mapcontainer = responsive() === 'sm' ? 'fuelMapConMob' : 'fuelMapCon';
        fuelStations.locations.initStateMapWithDealerData(fuelStations.markers, locationsData.locations, mapcontainer);
        var locationsTemplate = $('#template-mirai-fuel-station-results').html();
        var locationsHtml = Handlebars.hcompile(locationsTemplate , locationsData );
        $('.stations-panel-results').append(locationsHtml);

        // CONFINE LONG ADDRESS AND PROXMIITY TEXT TO 2 LINES.
        var resultsItems = $('.stations-panel-results').find('.result-item');
        var mob = false;
        if (responsive() === 'sm') {
          mob = true;
        }

        resultsItems.each(function (index, item) {
          var firstItem = $(item).find('p');
          if (mob) {
            firstItem = $(item).find('p').find('a');
          }
          var gHeight = mob ? 14 : 18;
          if (firstItem.height() > gHeight) {
            var proxmitytext = $(item).find('p').last().text();
            $(item).find('p').last().remove(); // REMOVE PROXMIMITY.
            firstItem.append((' | ' + proxmitytext))
          }
        })
        // RESET SCROLL POSITION:
        $('.stations-panel-results').scrollTop(previousScrollTop);

        // RESULT ITEM CLICK:
        $('.result-item').on('click', function () {
          fuelStations.selectedItemCoords = { lat: $(this).data('lat'), lng: $(this).data('lon') };
          fuelStations.resultItemClick = true;
          $(this).addClass('selected').siblings().removeClass('selected');
          var idx = $(this).data('index');

          if (responsive() === 'sm') {
            // BAT-3185: mobile functionality ends here.
            return;
          }

          fuelStations.maps.selectMarker(idx, true); // INFO WINDOW ON MAP, ignore the centering if it's the auto select.
          if (fuelStations.ignoreCenter) {
            fuelStations.ignoreCenter = false;
          } else {
            fuelStations.locations.centerMap($(this).data('lat'), $(this).data('lon'));
          }
        });

        // AUTO SELECT FIRST ITEM:
        if (fuelStations.displayPagerNum === 1 && responsive() !== 'sm') {
          setTimeout(function () {
            var firstItem  = $('.result-item')[0];
            var selectedIndex = 0;
            if (fuelStations.stationId) {
              $('.result-item').each(function (idx, item) {
                if (Number(fuelStations.stationId) === $(item).data('id')) {
                  firstItem = $(item);
                  selectedIndex = idx;
                  fuelStations.locations.centerMap($(firstItem).data('lat'),$(firstItem).data('lon'));
                  fuelStations.stationId = null;
                }
              });
            }
            fuelStations.ignoreCenter = true;
            fuelStations.defaultItemSelect = true;
            // IF WE NEED TO DISREGARD THE DEFAULT SELECTION RESULT EVENT, selectedIndex COULD BE USED TO SET THE ITEMS AS VISIBLY SELECTED.
            fuelStations.locations.setItemSelected(selectedIndex);
            fuelStations.maps.selectMarker(selectedIndex, null, true);
          }, 800);
        }

        if (responsive() === 'sm') {
          // SHOW THE 'NEAR YOU' display
          $('#searchLocation').text(searchValue);
          // DEFAULT TO LIST VIEW.
          $('#listSelector').addClass('active');
          $('.stations-panel-results').show();

          // List Results.
          $('#listSelector').on('click', function () {
            $('.stations-panel-results').show();
            $('#fuelMapConMob').hide();
            $('#fuelMapConMob').removeClass('viewable');
            $('#listSelector').addClass('active');
            $('#mapSelector').removeClass('active');
          });

          // Map Results.
          $('#mapSelector').on('click', function () {
            $('.stations-panel-results').hide();
            $('#fuelMapConMob').show();
            $('#fuelMapConMob').addClass('viewable');
            $('#listSelector').removeClass('active');
            $('#mapSelector').addClass('active');
            fuelStations.locations.initStateMapWithDealerData(fuelStations.markers, locationsData.locations, 'fuelMapConMob');
          });

          if (fuelStations.displayPagerNum === 1 && fuelStations.stationId || fuelStations.isSearchUrl) { // switch to map.
            $('#mapSelector').trigger('click');
          }

          // SELECT THE ITEM.
          var firstItem = $('.result-item')[0];
          resultsItems.each(function (index, item) {
            if (fuelStations.stationId) {
              $('.result-item').each(function (idx, item) {
                if (Number(fuelStations.stationId) === $(item).data('id')) {
                  firstItem = $(item);
                }
              });
            }
          });

          if (fuelStations.stationId) {
            setTimeout(function () {
              fuelStations.locations.centerMap($(firstItem).data('lat'),$(firstItem).data('lon'));
              setTimeout(function () {
                var idx = $(firstItem).data('index');
                fuelStations.maps.selectMarker(idx, null);// INFO WINDOW ON MAP.
              }, 10);
            }, 100);
          }

          fuelStations.isSearchUrl = false;
        }
        window.bat.util.loader.hideLoader();

        // VIEW MORE STATIONS.
        if (fuelStations.allLocations.length >= fuelStations.allResults.length) {
          $('#viewMoreStationsBtn').hide();
        } else {
          $('#viewMoreStationsBtn').on('click', function () {
            fuelStations.displayPagerNum++;
            fuelStations.locations.loadResults(null, true);
          });
        }

        // BAT25-139
        // if user has used geolcate, show their location on the map.
        if (fuelStations.useGeoLocate && responsive() === 'sm') {
          if (fuelStations.storedUserLocation) {
            fuelStations.maps.displayLocation(fuelStations.storedUserLocation)
            return;
          }
          self.getUserLocation = function () {
            return new Promise(function (resolve, reject) {
              navigator.geolocation.getCurrentPosition(function (position) {
                fuelStations.storedUserLocation = { lat: position.coords.latitude, lon: position.coords.longitude };
                resolve(fuelStations.storedUserLocation);
              });
            });
          }

          self.getUserLocation().then(function (obj) {
            fuelStations.maps.displayLocation(obj)
          });
        }
      }
    }
  };

  window.fuelStations = fuelStations; // REQUIRED FOR AJAX CALLBACKS.
  return fuelStations;
});

